/**
 * FOODSWORLD header — nav dropdowns, drawer breakpoint, sticky announcement hide
 */
const DESKTOP_NAV_MQ = window.matchMedia('(min-width: 1024px)');
const TABLET_MQ = window.matchMedia('(max-width: 1023px)');

function setMenuStyleForViewport() {
  const header = document.getElementById('header-component');
  if (!header) return;
  header.dataset.menuStyle = DESKTOP_NAV_MQ.matches ? 'menu' : 'drawer';
}

function closeAllNavPanels(except) {
  document.querySelectorAll('[data-fw-nav-panel]').forEach((panel) => {
    if (panel === except) return;
    panel.hidden = true;
    const id = panel.id;
    if (id) {
      document.querySelectorAll(`[aria-controls="${id}"]`).forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    }
  });
}

function initNavDropdowns() {
  const triggers = document.querySelectorAll('[data-fw-nav-trigger]');
  triggers.forEach((trigger) => {
    const controls = trigger.getAttribute('aria-controls');
    const panel = controls ? document.getElementById(controls) : null;
    if (!panel) return;

    const setPanelOpen = (open) => {
      if (!DESKTOP_NAV_MQ.matches) return;
      closeAllNavPanels(open ? panel : null);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    };

    trigger.addEventListener('click', (event) => {
      if (trigger.tagName !== 'BUTTON') return;
      event.preventDefault();
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      setPanelOpen(!expanded);
    });

    trigger.addEventListener('focus', () => {
      setPanelOpen(true);
    });

    const item = trigger.closest('.fw-header-nav__item');
    if (item && !item.dataset.fwNavDropdownBound) {
      item.dataset.fwNavDropdownBound = 'true';

      let closeTimer = null;
      const HOVER_CLOSE_DELAY_MS = 200;

      const cancelScheduledClose = () => {
        if (closeTimer !== null) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      const openPanel = () => {
        if (!DESKTOP_NAV_MQ.matches) return;
        cancelScheduledClose();
        closeAllNavPanels(panel);
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      };

      const closePanel = () => {
        if (!DESKTOP_NAV_MQ.matches) return;
        cancelScheduledClose();
        closeTimer = window.setTimeout(() => {
          closeTimer = null;
          trigger.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        }, HOVER_CLOSE_DELAY_MS);
      };

      const hoverTargets = [
        ...item.querySelectorAll('[data-fw-nav-trigger]'),
        item.querySelector('.fw-header-nav__link.fw-header-nav__trigger--nav'),
        panel,
      ].filter(Boolean);

      hoverTargets.forEach((target) => {
        target.addEventListener('pointerenter', () => {
          cancelScheduledClose();
          openPanel();
        });
      });

      item.addEventListener('mouseleave', closePanel);
      panel.addEventListener('mouseleave', closePanel);
    }
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.fw-header-nav')) return;
    closeAllNavPanels(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllNavPanels(null);
  });

  window.addEventListener(
    'scroll',
    () => {
      if (!DESKTOP_NAV_MQ.matches) return;
      closeAllNavPanels(null);
    },
    { passive: true }
  );
}

function initStickyAnnouncement() {
  const headerGroup = document.getElementById('header-group');
  if (!headerGroup) return;

  const onScroll = () => {
    if (!TABLET_MQ.matches) {
      headerGroup.classList.remove('fw-header--scrolled');
      return;
    }
    const scrolled = window.scrollY > 8;
    headerGroup.classList.toggle('fw-header--scrolled', scrolled);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/** Mississauga store clock — live weekday + hours */
function getTorontoHoursLabel() {
  const weekday = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Toronto',
    weekday: 'short',
  }).format(new Date());

  const hoursByDay = {
    Sun: 'SUN - 8:00 AM - 8:00 PM',
    Mon: 'MON - 7:00 AM - 10:00 PM',
    Tue: 'TUE - 7:00 AM - 10:00 PM',
    Wed: 'WED - 7:00 AM - 10:00 PM',
    Thu: 'THU - 7:00 AM - 10:00 PM',
    Fri: 'FRI - 7:00 AM - 10:00 PM',
    Sat: 'SAT - 7:00 AM - 8:00 PM',
  };

  return hoursByDay[weekday] || hoursByDay.Mon;
}

function initHoursToday() {
  const label = getTorontoHoursLabel();
  document.querySelectorAll('[data-fw-hours-today]').forEach((el) => {
    el.textContent = label;
  });
}

function init() {
  setMenuStyleForViewport();
  DESKTOP_NAV_MQ.addEventListener('change', setMenuStyleForViewport);
  initNavDropdowns();
  initStickyAnnouncement();
  initHoursToday();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
